import React from 'react';
import styled from 'styled-components';
import { canvas, textSecondary, textPrimary, borderSubtle, brand, info } from '../../tokens/colors';
import { fontFamily } from '../../tokens/typography';

export type TabsVariant = 'brand' | 'info';

interface TabItem {
  label: string;
  value: string;
  count?: number;
}

interface TabsProps {
  items: TabItem[];
  active: string;
  onChange: (value: string) => void;
  variant?: TabsVariant;
}

const Bar = styled.div`
  display: flex;
  align-items: stretch;
  border-bottom: 0.5px solid ${borderSubtle};
  background: ${canvas};
`;

const Tab = styled.button<{ $active: boolean; $activeColor: string }>`
  padding: 10px 18px;
  font-size: 12px;
  font-family: ${fontFamily};
  cursor: pointer;
  border: none;
  background: transparent;
  color: ${({ $active, $activeColor }) => $active ? $activeColor : textSecondary};
  border-bottom: 2px solid ${({ $active, $activeColor }) => $active ? $activeColor : 'transparent'};
  font-weight: ${({ $active }) => $active ? 600 : 400};
  white-space: nowrap;
  transition: color 0.1s;

  &:hover:not([data-active='true']) {
    color: ${textPrimary};
    background: rgba(0,0,0,0.03);
  }
`;

export const Tabs: React.FC<TabsProps> = ({ items, active, onChange, variant = 'brand' }) => {
  const activeColor = variant === 'brand' ? brand : info;
  return (
    <Bar>
      {items.map(item => (
        <Tab
          key={item.value}
          type="button"
          $active={item.value === active}
          $activeColor={activeColor}
          data-active={item.value === active}
          onClick={() => onChange(item.value)}
        >
          {item.label}
          {item.count !== undefined && ` (${item.count})`}
        </Tab>
      ))}
    </Bar>
  );
};
